"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsDropdown = void 0;
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const ListItem_1 = require("../ListItem");
const className_1 = require("../../utils/className");
exports.SmlsDropdown = ({ id, idInput, textLabel, defaultValue = '', textMobile = 'Digite seu país', errorMessage = 'Error message', actions = [], placeholder, disabled = false, forceError = false, value = '', onChange = () => undefined, onClick = () => undefined, onValid = () => undefined, onFocus, onBlur, openWhenTyping = false, isSelectSearch = true, }) => {
    const [dropdownOpen, setDropdownOpen] = react_1.useState(false);
    const [isTyping, setIsTyping] = react_1.useState(false);
    const [isFilled, setIsFilled] = react_1.useState(false);
    const [innerValue, setInnerValue] = react_1.useState(defaultValue);
    const [searchValue, setSearchValue] = react_1.useState(defaultValue);
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [isValidInput, setIsValidInput] = react_1.useState(true);
    const thisRef = react_1.useRef(null);
    const inputRef = react_1.useRef(null);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const openFilter = () => setDropdownOpen(true);
    const placeholderChange = () => {
        setSearchValue(innerValue);
        setInnerValue('');
    };
    const enableOutline = react_1.useCallback(() => {
        if (onFocus)
            onFocus();
        setIsFocused(true);
    }, []);
    const disableOutline = react_1.useCallback(() => {
        if (onBlur)
            onBlur();
        setIsFocused(false);
    }, []);
    const [isDesktop, setIsDesktop] = react_1.useState(false);
    const handleDebouncedValue = () => {
        const hasValue = innerValue.length > 0;
        const hasCorrespondentAction = hasValue
            ? actions.some((action) => action.name === innerValue)
            : true;
        setIsTyping(false);
        setIsFilled(hasValue);
        setIsValidInput(hasCorrespondentAction);
        onValid(hasCorrespondentAction);
        if (openWhenTyping) {
            onClick(hasCorrespondentAction ? innerValue : '');
            setDropdownOpen(!hasCorrespondentAction);
        }
    };
    const verifyIfIsDesktop = react_1.useCallback((width, height) => {
        if (width < 600 || height < 600)
            setIsDesktop(false);
        else
            setIsDesktop(true);
    }, []);
    react_1.useEffect(() => {
        verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        window.addEventListener('resize', () => {
            verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        });
    }, [verifyIfIsDesktop]);
    react_1.useEffect(() => {
        const debounceTimeout = setTimeout(handleDebouncedValue, 500);
        return () => {
            clearTimeout(debounceTimeout);
        };
    }, [innerValue]);
    react_1.useEffect(() => {
        if (innerValue !== value) {
            setInnerValue(value);
        }
    }, [value]);
    react_1.useEffect(() => {
        if (isTyping && openWhenTyping)
            setDropdownOpen(true);
    }, [isTyping]);
    const handleOnChange = react_1.useCallback((event) => {
        const text = event.target.value;
        setIsTyping(true);
        setInnerValue(text);
        onChange(event);
    }, []);
    const handleOnKeyDown = (event) => {
        var _a, _b, _c, _d, _e;
        if (event.key === 'ArrowDown' && thisRef.current) {
            const next = (_b = (_a = event.currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.children[0];
            if (next) {
                next.focus();
            }
        }
        if (event.key === 'ArrowUp' && thisRef.current) {
            const next = (_d = (_c = event.currentTarget.parentElement) === null || _c === void 0 ? void 0 : _c.previousElementSibling) === null || _d === void 0 ? void 0 : _d.children[0];
            if (next) {
                next.focus();
            }
            else {
                const inp = (_e = inputRef.current) === null || _e === void 0 ? void 0 : _e.children[0];
                if (inp) {
                    inp.focus();
                }
            }
        }
    };
    const handleInputKeyDown = (event) => {
        if (event.key === 'ArrowDown' && thisRef.current) {
            const next = thisRef.current.children[0].children[0];
            if (next) {
                next.focus();
            }
        }
        if (event.key === 'Escape' && dropdownOpen) {
            toggle();
        }
    };
    return (react_1.default.createElement("div", { className: className_1.mapToCssModules([
            !isDesktop && dropdownOpen ? 'dropdown-mobile' : 'input-group',
            disabled ? 'disabled' : '',
            isTyping ? 'typing' : '',
            isFilled && isDesktop ? 'filled' : '',
            isFocused ? 'input-outline' : '',
            !isValidInput || (forceError && !dropdownOpen) ? 'error' : '',
        ]) },
        textLabel && (isDesktop || (!isDesktop && !dropdownOpen)) && (react_1.default.createElement("label", { htmlFor: textLabel }, textLabel)),
        react_1.default.createElement(reactstrap_1.Dropdown, { id: id, isOpen: dropdownOpen, toggle: toggle },
            react_1.default.createElement("div", { className: "dropdown-toggle", ref: inputRef },
                isSelectSearch ? (react_1.default.createElement(reactstrap_1.Input, { id: idInput, value: innerValue, disabled: disabled, onChange: handleOnChange, placeholder: searchValue || placeholder, onFocus: enableOutline, onBlur: disableOutline, onKeyDown: handleInputKeyDown, onClick: () => {
                        openFilter();
                        placeholderChange();
                    }, autocomplete: "off" })) : (react_1.default.createElement(reactstrap_1.Input, { style: { cursor: 'pointer' }, id: idInput, value: innerValue, disabled: disabled, placeholder: searchValue || placeholder, onFocus: enableOutline, onBlur: disableOutline, onKeyDown: handleInputKeyDown, readOnly: true, onClick: () => {
                        openFilter();
                    }, autocomplete: "off" })),
                react_1.default.createElement("i", { onClick: () => {
                        var _a;
                        if (!disabled) {
                            toggle();
                            const input = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.children[0];
                            if (input) {
                                input.focus();
                            }
                        }
                    }, className: "material-icons notranslate" }, !isDesktop && dropdownOpen ? 'close' : 'expand_more')),
            react_1.default.createElement("ul", { className: "dropdown-menu", ref: thisRef }, isSelectSearch
                ? actions
                    .filter((action) => isFilled
                    ? action.name
                        .toLocaleUpperCase()
                        .includes(innerValue.toLocaleUpperCase()) ||
                        (action.label &&
                            action.label
                                .toLocaleUpperCase()
                                .includes(innerValue.toLocaleUpperCase()))
                    : true)
                    .map(({ id: optId, icon, label, name }) => (react_1.default.createElement(react_1.default.Fragment, null, isDesktop ? (react_1.default.createElement(ListItem_1.SmlsListItem, { id: optId, item: name, label: label, icon: icon, key: name, onClick: () => {
                        onClick(name);
                        setInnerValue(name);
                        setDropdownOpen(false);
                    }, onKeyDown: handleOnKeyDown })) : (react_1.default.createElement(ListItem_1.SmlsListItem, { id: `opt_${name}`, item: name, key: name, onClick: () => {
                        onClick(name);
                        setInnerValue(name);
                        setDropdownOpen(false);
                    }, onKeyDown: handleOnKeyDown })))))
                : actions.map(({ id: optId, icon, label, name }) => {
                    return (react_1.default.createElement(react_1.default.Fragment, null, isDesktop ? (react_1.default.createElement(ListItem_1.SmlsListItem, { id: optId, item: name, label: label, icon: icon, key: name, onClick: () => {
                            onClick(name);
                            setInnerValue(name);
                            setDropdownOpen(false);
                        }, onKeyDown: handleOnKeyDown })) : (react_1.default.createElement(ListItem_1.SmlsListItem, { id: `opt_${name}`, item: name, key: name, onClick: () => {
                            onClick(name);
                            setInnerValue(name);
                            setDropdownOpen(false);
                        }, onKeyDown: handleOnKeyDown }))));
                }))),
        isDesktop && (react_1.default.createElement("div", { className: "input-error" }, !isValidInput ||
            (forceError && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("i", { className: "material-icons notranslate" }, "\uE001"),
                react_1.default.createElement("label", { htmlFor: "input-text" }, errorMessage))))))));
};
//# sourceMappingURL=index.js.map